import React, { useEffect } from 'react';

// Material ui
import { Grid } from '@material-ui/core';

// Components
import TextInput from '@components/UI-KIT/Inputs/TextInput';
import SelectInput, { SelectOption } from '@components/UI-KIT/Inputs/SelectInput';
import CbuInput from '@components/UI-KIT/Inputs/CbuInput';
import CuitInput from '@components/UI-KIT/Inputs/CuitInput';
import AmountInput from '@components/UI-KIT/Inputs/AmountInput';
import Checkbox from '@components/UI-KIT/Checkbox';
import Button from '@components/UI-KIT/Button';
import Footer from '@components/UI-KIT/Footer';

// Types
import { CashAccount, BankAccount } from '..';
import { Account } from '@services/account';

// Icons
import { SmallStar, LeftArrow } from '@/assets/icons';

// Styles
import VARIABLES from '@/assets/variables';


interface Props {
    accountType: string;
    bankAccount: BankAccount;
    setBankAccount: React.Dispatch<React.SetStateAction<BankAccount>>;
    cashAccount: CashAccount;
    setCashAccount: React.Dispatch<React.SetStateAction<CashAccount>>;
    banks: SelectOption[];
    users: SelectOption[];
    account: Account;
    handlePostAccount: () => void;
    setActiveStep: React.Dispatch<React.SetStateAction<number>>;
    handleResetDrawer: () => void;
    postStatus: string;
}

const SecondStep: React.FC<Props> = ({
    accountType,
    bankAccount,
    setBankAccount,
    cashAccount,
    setCashAccount,
    banks,
    users,
    handlePostAccount,
    handleResetDrawer,
    account,
    postStatus
}) => {
    const buttonDisabled = accountType === 'Bank'
        ? !bankAccount.name
            || !bankAccount.cbu
            || bankAccount.cbu.length < 22
            || !bankAccount.cuit
            || bankAccount.cuit.length < 11
            || !bankAccount.holderName
            || !bankAccount.bank
            || postStatus === 'pending'
        : !cashAccount.name
            || postStatus === 'pending'
            || !cashAccount.user;

    useEffect(() => {

    }, [ ]);

    return (
        <>
            { accountType === 'Bank' && (
                <>
                    <TextInput
                        label="Nombre de la cuenta"
                        placeholder={'Ejemplo: "Mi cuenta Galicia"'}
                        value={bankAccount.name}
                        onChange={(name: string) => setBankAccount(prevState => ({
                            ...prevState,
                            name
                        }))}
                    />
                    <SelectInput
                        label="Banco"
                        placeholder="Elige un banco.."
                        value={banks.find(({ value }: SelectOption) => value.id === bankAccount.bank)}
                        onChange={(bank: any) => setBankAccount(prevState => ({
                            ...prevState,
                            bank: bank?.id
                        }))}
                        options={banks}
                    />
                    <CbuInput
                        label="CBU"
                        value={bankAccount.cbu}
                        onChange={(cbu: string) => setBankAccount(prevState => ({
                            ...prevState,
                            cbu
                        }))}
                    />
                    <TextInput
                        label="Titular de la cuenta"
                        value={bankAccount.holderName}
                        onChange={(holderName: string) => setBankAccount(prevState => ({
                            ...prevState,
                            holderName
                        }))}
                    />
                    <CuitInput
                        label="CUIT"
                        value={bankAccount.cuit}
                        onChange={(cuit: string) => setBankAccount(prevState => ({
                            ...prevState,
                            cuit
                        }))}
                    />
                    { !account && (
                        <AmountInput
                            optional
                            label="Saldo inicial"
                            placeholder="$0.00"
                            value={bankAccount.initialAmount}
                            onChange={(initialAmount: number) => setBankAccount(prevState => ({
                                ...prevState,
                                initialAmount
                            }))}
                        />
                    )}
                    <Grid
                        container
                        style={{ marginBottom: '3rem' }}
                    >
                        <Checkbox
                            checked={bankAccount.isDefault}
                            variant="switch"
                            label="Convertir en cuenta principal"
                            onChange={() => setBankAccount(prevState => ({
                                ...prevState,
                                isDefault: !prevState.isDefault
                            }))}
                        />
                        <Grid
                            item
                            container
                            xs={2}
                            alignItems="center"
                            style={{ marginLeft: '.5rem' }}
                        >
                            <SmallStar
                                color={VARIABLES.palette.secondary_color}
                            />
                        </Grid>
                    </Grid>
                </>
            )}
            { accountType === 'Cash' && (
                <>
                    <TextInput
                        label="Nombre de la cuenta"
                        placeholder={'Ejemplo: "Mi cuenta Galicia"'}
                        value={cashAccount.name}
                        onChange={(name: string) => setCashAccount(prevState => ({
                            ...prevState,
                            name
                        }))}
                    />
                    <SelectInput
                        label="Usuario asociado"
                        placeholder="Selecciona un usuario"
                        value={cashAccount.user}
                        onChange={(user: any) => setCashAccount(prevState => ({
                            ...prevState,
                            user: user?.id
                        }))}
                        options={users}
                    />
                </>
            )}
            <Footer
                className="AOL-Account-stepper-footer"
            >
                <Grid
                    container
                    justify="space-between"
                >
                    <Button
                        label="Anterior"
                        level={3}
                        disabled={Boolean(account)}
                        icon={(
                            <LeftArrow
                                color={VARIABLES.palette.secondary_color}
                            />
                        )}
                        onClick={() => handleResetDrawer()}
                    />
                    <Button
                        label="Guardar"
                        disabled={buttonDisabled}
                        onClick={() => handlePostAccount()}
                        loadingEvent
                    />
                </Grid>
            </Footer>
        </>
    );
};

export default SecondStep;